import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { RoutePath } from '@/routes';

/**
 * The prototype's `Back to sign in` affordance, on the two screens a signed-out
 * user can reach without a token: `/forgot-password` and `/signup`.
 *
 * `intent.md § FR-14` (auth-screens-redesign) originally grouped this link with
 * the prototype's temporary scaffolding and declined to build it. That was
 * wrong on the evidence: the capture draws `Back to app` in the hot pink the
 * ticket calls temporary, and `Back to sign in` in `--primary`, the same blue
 * as every shipped link. Overturned by the human 2026-08-19; FR-14 is amended
 * to the two genuinely temporary links.
 *
 * Positioned against the auth panel (`AuthLayout`'s right column is
 * `relative`), top-left, matching the capture. `AuthLayout` itself still
 * renders no navigation of its own -- this is a page-level child, so
 * `/login` and `/reset-password` are unchanged.
 */
export const BackToSignInLink = () => (
  <Link
    to={RoutePath.Login}
    className="absolute left-6 top-6 inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline"
  >
    <ArrowLeft aria-hidden="true" className="h-4 w-4" />
    Back to sign in
  </Link>
);
